const angular = require('angular');
const moment = require('moment');
const app = angular.module('learn-directives');
/**
 * Defines the user likes component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('invertedMessages', ['Application', function (Application) {
  return {
    restrict: 'E',
    replace: true,
    scope: {},
    template: require('../../templates/directives/inverted-messages.html'),
    controller: ['$scope', '$timeout', function ($scope, $timeout) {
      var self = this;
      var idCharacters = 'abcdefghijklmnopqrstuvwzyz';

      self.messages = Application.messaging.getMessages();

      self.goTo = function(link) {
        if (!link) {
          return;
        }
        Application.navigation.goTo(link);
      };

      self.removeMessage = function(index) {
        self.messages[index].show = false;
        $timeout(function() {
          Application.messaging.removeMessage(index);
        }, 500);
      };

      var setRemoval = function(index) {
        var tempId = '';
        var duration = self.messages[index].duration;
        if (!duration) {
          return;
        }

        for (var i = 0; i < 10; i++) {
          tempId += idCharacters[Math.floor(Math.random() * idCharacters.length - 1)];
        }

        self.messages[index].removeId = tempId;
        $timeout(function() {
          var itemIndex;
          for (var i = 0; i < self.messages.length; i++) {
            if (self.messages[i].removeId === tempId) {
              self.messages.splice(i, 1);
              return;
            }
          }
        }, duration * 1000);

      };

      $scope.$watch('messageViewer.messages', function(newVal, oldVal) {
        var index;
        var tempId = '';
        if (!newVal) {
          return;
        }

        if (newVal && newVal.length && oldVal && oldVal.length && oldVal.length > newVal.length) {
          return;
        }

        for (var i = 0; i < 10; i++) {
          tempId += idCharacters[Math.floor(Math.random() * idCharacters.length - 1)];
        }

        if (newVal.length > oldVal.length) {
          index = newVal.length - 1;
          self.messages[index].showId = tempId;
          // timeout is needed to apply the class after the element is built
          $timeout(function() {
            for (var i = 0; i < self.messages.length; i++) {
              if (self.messages[i].showId === tempId) {
                self.messages[i].show = true;
                $scope.$apply();
                return;
              }
            }
          }, 10);
          setRemoval(index);
        }

      }, true);

    }],
    controllerAs: 'messageViewer'
  };
}]);
